

















































































import Vue from 'vue';
import { mapActions } from 'vuex';

import { ModuleViewType, Module } from '@/models/configurator/module';
import ModuleOrderSetupDialog from '@/components/configurator/modules/ModuleOrderSetupDialog.vue';
import { get } from 'vuex-pathify';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ALPage from '@/components/core/Page/ALPage.vue';
import ModuleCardList from '@/components/configurator/modules/ModuleCardList.vue';
import ModuleList from '@/components/configurator/modules/ModuleList.vue';
import ModuleViewSelector from '@/components/configurator/modules/ModuleViewSelector.vue';
import ModuleFormDialog from '@/components/configurator/ModuleFormDialog.vue';

enum ModuleTab {
  Active,
  Archived
}

export default Vue.extend({
  name: 'ModuleListPage',

  components: {
    ALPage,
    ErrorAlert,
    ModuleOrderSetupDialog,
    ModuleViewSelector,
    ModuleFormDialog
  },
  data: () => ({
    labels: {
      titleModule: 'Edit Module',
      addModule: 'Add Module'
    },
    search: '',

    errorMessage: '',
    detailErrorMessage: '',

    view: ModuleViewType.Card,

    archivedTab: 0,

    cloneIndex: -1,

    openTimeout: undefined as number | undefined
  }),

  computed: {
    getModuleById: get<(id: number) => Module>(
      'configuratorModule/getModuleById'
    ),
    getActiveModules: get<Module[]>('configuratorModule/getActiveModules'),
    getArchivedModules: get<Module[]>('configuratorModule/getArchivedModules'),

    currentViewComponent(): typeof ModuleCardList | typeof ModuleList {
      switch (this.view) {
        case ModuleViewType.Card:
          return ModuleCardList;
        case ModuleViewType.List:
        default:
          return ModuleList;
      }
    },

    modules(): Module[] {
      switch (this.archivedTab) {
        case ModuleTab.Archived:
          return this.getArchivedModules;

        case ModuleTab.Active:
        default:
          return this.getActiveModules;
      }
    }
  },

  mounted() {
    this.searchModules();
  },

  methods: {
    ...mapActions('configuratorModule', [
      'deleteModule',
      'fetchModules',
      'cloneModule'
    ]),

    searchModules() {
      this.fetchModules().catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      });
    },

    addModule() {
      const productConfigModuleFormDialog = this.$refs
        .productConfigModuleFormDialog as InstanceType<typeof ModuleFormDialog>;
      productConfigModuleFormDialog.open();
    },

    editModule(module: Module) {
      const productConfigModuleFormDialog = this.$refs
        .productConfigModuleFormDialog as InstanceType<typeof ModuleFormDialog>;
      productConfigModuleFormDialog.open(module);
    },

    async destroyModule(id: number) {
      this.clearAllErrors();

      const module = this.getModuleById(id);

      if (!module) return;

      const confirm = (this as any).$refs.confirm;
      if (
        await confirm.open(
          'Delete Module',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${module.name}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        await this.deleteModule(module.id).catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        });
      }
      return;
    },

    /**
     * Clear any pending delay timers from executing
     */
    clearDelay(): void {
      clearTimeout(this.openTimeout);
    },

    /**
     * Sets `isCloning` flag to true after `500ms` delay
     */
    startIsCloningFromDelay(index: number) {
      this.clearDelay();

      this.openTimeout = setTimeout(() => {
        this.cloneIndex = index;
      }, 500);
    },

    finishCloningAndClearDelay() {
      this.clearDelay();

      this.cloneIndex = -1;
    },

    copyModule({ module, index }: { module: Module; index: number }) {
      this.clearAllErrors();

      this.startIsCloningFromDelay(index);

      this.cloneModule(module.id)
        .then(result => {
          this.editModule(result);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.finishCloningAndClearDelay();
        });
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  }
});
